import { render, staticRenderFns } from "./_content_create_article_form.vue?vue&type=template&id=239301b2"
import script from "./_content_create_article_form.vue?vue&type=script&lang=js"
export * from "./_content_create_article_form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports